// extracted by mini-css-extract-plugin
export const spinnerWrapper = "Spinner-module--spinnerWrapper--27eI6";
export const centered = "Spinner-module--centered--WCl7d";
export const spinner = "Spinner-module--spinner--3e-oP";
export const load = "Spinner-module--load--2Ny8A";